import { 
  EuiFlexGroup,
    EuiFlexItem,
    EuiPage,
    EuiPageBody,
    EuiPageContent,
    EuiPageContentBody,
    EuiPageHeader,
    EuiPageHeaderSection,
    EuiTitle,} from '@elastic/eui';
  import React from 'react';
  import {UsuariosExpatriadosContainer} from './container';
  import { useLanguage } from '../../../../../shared/hooks/Language';
  
  export const UsuariosExpatriadosView = () =>{
    const {translate} = useLanguage();
  
    return (
      <EuiPage>
      <EuiPageBody>
        <EuiPageHeader>
          <EuiFlexGroup>
            <EuiFlexItem>
              <EuiTitle size="l">
              <h1>{translate('usuarios-expatriados').toUpperCase()}</h1>
              </EuiTitle>
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiPageHeader>
        <EuiPageContent>
          <EuiPageContentBody>
            <UsuariosExpatriadosContainer translate={translate}/>
          </EuiPageContentBody>
        </EuiPageContent>
      </EuiPageBody>
    </EuiPage>
    )
  }